<div *ngIf="errorMessages.length > 0">
  <p-messages severity="error">
    <ng-template pTemplate>
      <span class="p-message-icon pi pi-times-circle"></span>
      <span class="p-ml-2"
        >{{changeControlErrorReminder}}</span
      >
      <ul>
        <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
      </ul>
    </ng-template>
  </p-messages>
</div>
<form [formGroup]="changeControlForm" *ngIf="islookupDataLoaded">
  <div class="general-tab">
    <div class="fields-row">
      <div class="field-title field-required">
        <bpt-text-input
          label="Title"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.title }"
          [disabled]="false"
          id="changeControlTitle"
          formControlName="title"
          [maxlength]="255"
        ></bpt-text-input>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Priority"
          [options]="lookupData?.priorities ?? []"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.priority }"
          id="changeControlPriority"
          formControlName="priority"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Reason"
          [options]="lookupData?.reasons ?? []"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.reason }"
          id="changeControlReason"
          formControlName="reason"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Impact"
          [options]="lookupData?.impacts ?? []"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.impact }"
          [editable]="false"
          id="changeControlImpact"
          formControlName="impact"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Category"
          [options]="lookupData?.categories ?? []"
          [required]="true"
          [editable]="false"
          [ngClass]="{ 'error-highlight': mandatoryFields.category }"
          id="changeControlCategory"
          formControlName="category"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Change Request Source"
          [options]="lookupData?.sources ?? []"
          [required]="true"
          id="changeControlchangeRequestSource"
          formControlName="changeRequestSource"
          [ngClass]="{ 'error-highlight': mandatoryFields.changeRequestSource }"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-datetime
          id="changeControlTargetCompletionDate"
          [minDate]="minStartDateValue?.toString() ?? ''"
          label="Target Completion Date"
          formControlName="targetCompletionDate"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.targetCompletionDate }"
        ></bpt-datetime>
      </div>
      <div class="field mt-3">
        <p-checkbox
          p-label-active
          label="Risk Assessment Required?"
          [binary]="true"
          formControlName="riskAssessmentRequired"
          (ngModelChange)="(1)"
        >
        </p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForRiskAssessmentRequired }}"
        ></i>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-text-input
          formControlName="currentState"
          [highlightAllOnFocus]="true"
          [multiLine]="true"
          [rows]="2"
          [autoResize]="true"
          [required]="true"
          id="description"
          label="Current State"
          [ngClass]="{ 'error-highlight': mandatoryFields.currentState }"
        ></bpt-text-input>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-text-input
          formControlName="futureState"
          [highlightAllOnFocus]="true"
          [multiLine]="true"
          [rows]="2"
          [autoResize]="true"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.futureState }"
          id="description"
          label="Future State"
        ></bpt-text-input>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-text-input
          formControlName="rationale"
          [highlightAllOnFocus]="true"
          [multiLine]="true"
          [rows]="2"
          [autoResize]="true"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.rationale }"
          id="description"
          label="Rationale"
        ></bpt-text-input>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="eQMS Scope(s)"
          [options]="eQMSScopeList ?? []"
          [required]="true"
          id="changeControleQMSScope"
          formControlName="eQMSScopes"
          [editable]="false"
          [showClear]="true"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.eQMSScopes }"
          [showFilter]="true"
          (ngModelChange)="validateEqmsScopes()"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Responsible Sub-BU"
          [options]="sbuList ?? []"
          id="changeControlResponsibleSubBU"
          formControlName="responsibleSubBU"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true" 
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field mt-3">
        <p-checkbox
          p-label-active
          label="Client Notification/Approval Required?"
          [binary]="true"
          formControlName="clientNotificationOrApprovalRequired"
          (ngModelChange)="validateEqmsScopes()"
        >
        </p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForClientNotificationOrApprovalRequired }}"
        ></i>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Implementation Owner(s)"
          [required]="true"
          [options]="implementationOwnersList ?? []"
          id="changeControlImplementationOwners"
          formControlName="implementationOwners"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.implementationOwners }"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Collaborator(s)"
          [required]="true"
          [editable]="false"
          [options]="collaboratorsList ?? []"
          id="changeControlCollaborators"
          formControlName="collaborators"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.collaborators }"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Internal Client Contact"
          [editable]="false"
          [required]="isInternalClientContactRequired"
          [options]="internalClientContactsList ?? []"
          id="changeControlInternalClientContact"
          formControlName="internalClientContact"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{'error-highlight' : isInternalClientContactMandatory }"
        >
        </bpt-dropdown>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Reviewer(s)"
          [required]="true"
          [options]="reviewersList ?? []"
          id="changeControlReviewers"
          formControlName="reviewers"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.reviewers }"
          [valueField]="valueField"
          [labelField]="labelField"
          (ngModelChange)="VerifyReviewerAndApprover()"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Approver(s)"
          [required]="true"
          [editable]="false"
          [options]="approversList ?? []"
          id="changeControlApprovers"
          formControlName="approvers"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.approvers }"
          [valueField]="valueField"
          [labelField]="labelField"
          (ngModelChange)="VerifyReviewerAndApprover()"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Verifier(s)"
          [required]="true"
          [editable]="false"
          [options]="verifiersList ?? []"
          id="changeControlVerifiers"
          formControlName="verifiers"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.verifiers }"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
    </div>

    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Notified User(s)"
          id="changeControlNotifiedUsers"
          formControlName="notifiedUsers"
          [editable]="false"
          [showClear]="true"
          [options]="notifiedUsersList ?? []"
          [multiSelect]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
      </div>
      <div class="field">
      </div>
    </div>
  </div>
  <div class="buttons">
    <p-button
      appPreventDoubleClick
      *ngIf="isEditSlider"
      label="Save"
      type="submit"
      id="generalDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="updateChangeManagement()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
    label="Next"
    type="submit"
    id="generalDetailsNextButton"
    styleClass="bpt-button-compact"
    class="align-right mr-3"
      (debounceClick)="openNextTab()"
    >
    </p-button>
  </div>
</form>

<p-dialog
[(visible)]="showDeletedFilesConfirmationModal"
[style]="{ width: '30vw' }"
(onHide)="closeConfirmationModal()"
[modal]="true"
>
<ng-template pTemplate="header">
  <span class="font-semibold text-xl">Confirmation</span>
</ng-template>
<div>
  <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
  <span>{{ deleteAttachmentConfirmationMessage }}</span>
</div>
<ul>
  <li *ngFor="let deleteAttachment of deletedAttachments">
    {{ deleteAttachment.attachmentPath }}
  </li>
</ul>
<ng-template pTemplate="footer">
  <p-button
    appPreventDoubleClick
    label="No"
    type="submit"
    icon="pi pi-times"
    id="deletedFilesConfirmationNoButton"
    styleClass="p-button-outlined"
    class="align-right"
    (debounceClick)="closeConfirmationModal()"
  >
  </p-button>
  <p-button
    appPreventDoubleClick
    label="Yes"
    icon="pi pi-check"
    type="submit"
    id="deletedFilesConfirmationYesButton"
    class="align-right"
    (debounceClick)="UpdateChangeControl()"
  >
  </p-button>
  
</ng-template>
</p-dialog>


<app-dialog *ngIf="isReasonForChangeControlUpdateRequired"
[reasonValidationMessage]="reasonValidationMessage"
[heading]="heading"
(saveDocumentwithReason)="saveChangeControlwithReason($event)" 
(isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveAssignmentGroupwithInactiveUsers()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>
